import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";
import { Popup } from "../popup/popup.comp";

export const StyledSectionTags = styled.div`
  border-bottom: 1px solid ${CSSVars.gray50};
  padding: 20px 40px;
  position: relative;

  @media (max-width: 1000px) {
    padding: 15px 20px;
    top: 60px;
  }

  .tags-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;

    .tag {
      padding: 10px 20px;
      background: ${CSSVars.gray50};
      color: ${CSSVars.black};
      border: 2px solid transparent;
      border-radius: 25px;
      font-size: ${CSSVars.fontSizeSM};
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;
      text-transform: capitalize;
      white-space: nowrap;

      &:hover {
        background: ${CSSVars.gray100};
        border-color: ${CSSVars.blue400};
      }

      &.active {
        background: ${CSSVars.blue500};
        color: ${CSSVars.white};
        border-color: ${CSSVars.blue500};
      }

      @media (max-width: 768px) {
        padding: 8px 16px;
        font-size: ${CSSVars.fontSizeXS};
      }
    }
  }
`;

export const StyledWidgetExamplesSection = styled.section`
  padding: 100px 40px;

  @media (max-width: 1000px) {
    padding: 50px 20px;
  }

  .tag-section {
    margin-bottom: 80px;

    &:last-child {
      margin-bottom: 0;
    }

    .tag-title {
      font-size: ${CSSVars.fontSize2XL};
      font-weight: 600;
      color: ${CSSVars.black};
      margin-bottom: 40px;
      text-align: center;
      text-transform: capitalize;

      @media (max-width: 768px) {
        font-size: ${CSSVars.fontSizeXL};
        margin-bottom: 30px;
      }
    }
  }

  .templates-content-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-gap: 50px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

    .template-details {
      text-align: left;
      margin-top: 10px;
      color: ${CSSVars.black};
      font-size: ${CSSVars.fontSizeMD};
      padding: 0 10px;

      h3 {
        font-weight: 500;
      }

      p {
        font-weight: 300;
      }

      .template-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-top: 8px;

        .template-tag {
          display: inline-block;
          padding: 4px 10px;
          background: ${CSSVars.gray50};
          color: ${CSSVars.gray600};
          border-radius: 20px;
          font-size: ${CSSVars.fontSizeXS};
          font-weight: 500;
          text-transform: capitalize;
        }
      }
    }

    .template {
      height: 250px;
      background-color: ${CSSVars.white};
      border: 2px solid ${CSSVars.gray50};
      border-radius: 5px;
      overflow: hidden;
      position: relative;

      .template-thumbnail {
        width: 101%;
        height: 101%;
        object-fit: cover;
        object-position: center;
        border-radius: 3px;
        transition: filter 0.3s ease-in-out;
        
        &.bar {
          background-color: ${CSSVars.gray50};
          object-fit: contain;
          object-position: center top;
        }
      }

      .template-actions {
        display: flex;
        gap: 10px;
        position: absolute;
        z-index: 1;
        width: 100%;
        padding: 10px;
        right: 0;
        bottom: -50px;
        opacity: 0;
        transition: all 0.3s ease-in-out;

        > button,
        > a {
          flex: 1 0;
        }
        > a {
          margin: 0 !important;
        }

        > button {
          height: max-content;
          font-size: ${CSSVars.fontSizeSM};
          padding: 8px 20px;
        }
      }

      .add-template {
        background-color: #ecf0ff;
        border-radius: 3px;
        width: 100%;
        height: 100%;
        max-width: 100%;
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: filter 0.3s ease-in-out;

        .icon {
          color: ${CSSVars.blue400};
        }

        + a {
          position: absolute;
          margin: 10px;
          right: 0;
          bottom: 0;
          width: 96%;
          margin: 2%;
          bottom: -40px;
          opacity: 0;
          transition: all 0.3s ease-in-out;
        }
      }

      a {
        &:not(.no-external-colors) {
          background-color: #e4eaff;
          color: ${CSSVars.blue500};
        }

        cursor: pointer;
        margin-top: 20px;
        font-size: ${CSSVars.fontSizeSM};
        border-radius: 5px;
        padding: 8px 20px;
        width: 100%;

        &:hover {
          opacity: 0.8;
        }
      }

      &:hover {
        .template-actions {
          bottom: 0;
          opacity: 1;
        }

        .template-thumbnail,
        .add-template {
          filter: brightness(75%);

          &.add-template + a {
            bottom: 0;
            opacity: 1;
          }
        }
      }
    }
  }
`;

export const StyledPopup = styled(Popup)`
  .widget-display {
    position: relative;
    width: 100%;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.08);
    border-radius: 15px;
    /* max-height: 400px; */
    overflow: scroll;
    margin-top: 20px;
    height: calc(100vh - 250px);

    iframe {
      height: 98%;
    }

    @media screen and (min-width: ${CSSVars.breakpointMD}) {
      /* max-height: 600px; */
    }
  }

  .nindo-popup-title {
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 32px;
    padding: 0;
    margin: 0;

    .template-preview {
      min-height: 600px;
    }

    .preview-description {
      flex: 1 0;
      text-align: left;

      .preview-title {
        font-weight: 600;
        font-size: ${CSSVars.fontSizeXL};
      }

      .preview-description {
        margin-top: 6px;
        font-size: ${CSSVars.fontSizeLG};
        font-weight: 300;
      }
    }

    button {
      padding: 0;

      a {
        padding: 8px 15px;
      }
    }
  }
`;
